export default {
    lotteryQr: 'QRCODE',
    checkResult: 'Per partecipare all\'estrazione',
    downloadApp: 'Scarica APP',
    prize: 'Premio',
    introTitle: 'Come fare l\'estrazione e riscuotere',
    lotteryRule: 'Regole lotteria',
    checkDetailsHint: '（Clicca per vedere dettagli）',
    addCardHint1: 'Aggiungi la tua carta ',
    addCardHint2: ' a Laidan',
    howGetCard: 'Come ottenere la tua carta',
    getCardText: 'Puoi usare questa carta con l\'app mobile gratuita, Laidan!',
    flowTitle1: 'Installa Laidan',
    flowText1: 'Se non hai Laidan, puoi ottenerlo per liberare e snellire il tuo portafoglio!',
    flowTitle2: 'Aggiungi la tua carta',
    flowText2: 'Una volta installato Laidan, fai clic su questo pulsante per aggiungere la carta all\'app!',
    flowTitle3: 'Tutto pronto!',
    flowText3: 'Goditi il tuo shopping mobile con esperienza migliorata!',
    flowBtnText1: 'VAI SU',
    flowBtnText2: 'Scarica da',
    flowBtnText3: 'Aggiungi a',
    merchantOs: 'Il tuo sistema da commerciante',
    howCreateOs: 'Come creare il tuo sistema',
    createOsText: 'Puoi gestire le tue merci e creare un sistema VIP tramite l\'app mobile gratuita Joinku',
    kuTitle1: 'Scarica Joinku',
    kuText1: 'Se non hai Joinku, puoi usarlo per risparmiare tempo! ',
    kuTitle2: 'Visualizza il tuo sistema',
    kuText2: 'Una volta installato Joinku, fai clic su questo pulsante per visualizzare i membri e gli ordini! ',
    kuTitle3: 'Tutto completato! ',
    kuText3: 'Goditi la tua migliore esperienza di amministrazione del sistema! ',
    taxExpert: "Il tuo sistema di scontrini elettronici",
    howGetTax: 'Come ottenere il tuo scontrino elettronico',
    getTaxText: 'Puoi ricevere i tuoi scontrini elettronici e partecipare alle estrazioni di premi tramite l\'app mobile gratuita Laidan',
    danTitle1: 'Scarica Laidan',
    danText1: 'Se non hai Laidan, puoi usarlo per ricevere di sconti e promozioni! ',
    danTitle2: 'Sfoglia le tue attività',
    danText2: 'Una volta installato Laidan, fai clic su questo pulsante per partecipare alla tua promozione! ',
    danText3: 'Goditi la tua migliore esperienza con le offerte per dispositivi mobili! ',
    inviteCashDedu: 'Invita la detrazione in contanti',
    inviteCode: 'Codice di invito',
    copyInviteCode: 'Fai clic per copiare il codice di invito! ',
    copySucceed: 'Copia riuscita! ',
    copyError: 'Copia fallita! ',
    memberSystem: 'Sistema per membri',
    memberSystemText: 'Ogni volta che inviti un nuovo utente a registrarsi come utente Joinku con il tuo codice di invito, puoi ottenere una detrazione della quota annuale di 100€',
    inviteTitle2: 'Imposta codice di invito',
    inviteText2: 'Una volta installato Joinku, copia il codice di invito e fai clic su questo pulsante per accedere a Joinku!',
    inviteText3: 'Ottieni una detrazione in contanti della quota annuale! ',
    flowBtnText4: 'Vai a vedere',
    phoneLabel: 'Telefono:',
    addressLabel: 'indirizzo:',
    readAndAccept: 'leggi e accetta',
    privacyPolicy: 'politica sulla riservatezza',
    startLottery: 'iniziare la lotteria',
    usePhoneLogin: 'Accedi con numero di cellulare',
    useEmailLogin: 'Accedi tramite e-mail',
    phoneLogin: 'Accesso tramite numero di cellulare',
    countryCodeSearch: 'Inserisci il nome del paese, il prefisso per la ricerca',
    emailLogin: 'E-mail di accesso',
    getAuthCode: 'ottieni il codice di verifica',
    inpPhoneHint: 'Inserisci il numero di telefono',
    inpEmailHint: 'Inserisci il tuo account e-mail',
    inpAuthCode: 'si prega di inserire il codice di verifica',
    codeVerifyTitle: 'Si prega di completare il controllo di sicurezza',
    codeVerifyHint: 'Scorri verso destra per completare la verifica',
    verifyError: 'Validazione fallita',
    verifyFinish: 'controllo completato',
    login: 'Login',
    clickCheck: 'clicca per vedere',
    downAppPrize: 'Scarica l\'APP per visualizzare i premi',
    lottoErrorHint: 'Codice lotteria errato',
    lottoNoloHint: 'Si prega di attendere pazientemente',
    lottoNowiHint: 'dispiace non aver vinto',
    lottoWinnHint: 'Congratulazioni per aver vinto il premio!!!',
    lottoUsedHint: 'Questo codice lotteria è già stato utilizzato',
    partPlatLotto: 'Benvenuti a partecipare alla lotteria della piattaforma',
    skipPlatLotto: 'Quindi passa automaticamente alla pagina della lotteria della piattaforma',
    skipPrize: 'Passa automaticamente alla pagina del premio',
    allowMerRead: 'Consenti ai commercianti di accedere alle mie informazioni:',
    infoMore: 'nome, numero di telefono, compleanno',
    joinMember: 'unisciti a un membro',
    checkMember: 'visualizzare i membri',
    drawPlatCoupon: 'Ricevi i coupon della piattaforma',
    moreDisDis: 'Più sconti',
    firLoginDraw: 'La prima volta che accedi all\'APP, puoi ottenere',
    clickDown: 'Fare clic per scaricar',
    appDraw: 'APP per ricevere',
    validTime: 'Valido fino a',
    useAwaCodeHint: 'Usalo per il tuo prossimo pasto e presenta il codice a barre alla cassa',
    platLottoCode: 'Codice della lotteria della piattaforma',
    lottoCode: 'Codice estrazione fortunata:',
    lotteryTime: 'Disegna il tempo: ',
    noLottery: 'Non disegnato',
    yetWinning: 'Ha vinto',
    noWinning: 'Non ho vinto',
    haveUsed: 'Usato',
    sellOut: 'Esaurito',
    currentPrice: 'Imposta data/ora',
    includeAllergen: 'Include allergeni',
    details: 'Dettagli',
    selectAllergen: 'Allergeni',
    rawMaterials: 'Ingredienti:',
    cookingWay: 'Descrizione:',
    allergens: 'Allergeni:',
    mayAddMaterials: 'Ingredienti aggiungibili:',
    mayMinusMaterials: 'Ingredienti eliminabili:',
    taste: 'Preferenza di gusto:',
    selectedGroupNum: 'Quantità piatti selezionata:',
    priceZero: 'piatti a prezzo 0',
    priceNoZero: 'Piatti con prezzo diverso da 0',
    notSetMealDishes: 'Non ci sono piatti in questo set',
    notGroupDishes: 'Non ci sono piatti in questa categoria',
    notDishesMat: 'Non ci sono materie prime in questo piatto',
    notGroupMat: 'Non ci sono materie prime in questa categoria',
    selectFinish: 'Selezionato',
    noSelectFinish: 'Da selezionare',
    cancel: 'Annulla',
    woka: {
        activityPage: 'Pagina dell\'evento',
        unlockDish: 'Sblocca piatti gratuitamente',
        unlockText: 'Partecipando all\'attività di condivisione secondo le regole dell\'evento, puoi sbloccare gratuitamente qualsiasi piatto!',
        activityRule: 'Regole dell\'evento',
        ruleText: 'Scegli uno dei seguenti modi, carica uno screenshot nella posizione indicata e riceverai un codice per riscattare un piatto.',
        issueWork: 'Pubblica un\'opera',
        weChat: 'WeChat',
        wechatText: 'Condividi sul tuo profilo e raccogli 20 "Mi piace" dai tuoi amici.',
        douyinText1: '1. Partecipa all\'argomento #AssistenteCucinaAI#',
        douyinText2: '2. Commento in evidenza',
        douyinText3: '3. Pubblica su TikTok @xxxx',
        redBook: 'Xiaohongshu',
        redBookText2: '2. Segna la tua posizione',
        instagramText1: '1. Pubblica una storia + post/Reels pubblici',
        instagramText2: '2. @Menziona 3 amici',
        tikTokText1: '1. Storia a tempo',
        tikTokText2: '2. Opera pubblica @menziona 3 amici',
        partActivity: 'Partecipa all\'evento',
    }
};
